var exports = {
  "uW": "PurchaseHistorySection.module__section___cGhhNX",
  "Nr": "PurchaseHistorySection.module__card___cGhhNX",
  "Vg": "PurchaseHistorySection.module__grid___cGhhNX",
  "Qs": "PurchaseHistorySection.module__content___cGhhNX",
  "DD": "PurchaseHistorySection.module__title___cGhhNX",
  "h_": "PurchaseHistorySection.module__description___cGhhNX",
  "be": "PurchaseHistorySection.module__accordionStack___cGhhNX",
  "JC": "PurchaseHistorySection.module__accordion___cGhhNX",
  "x6": "PurchaseHistorySection.module__button___cGhhNX",
};

module.exports = exports;
